import { createLoadOnceAPIHook } from '@/lib/react-hooks/generic-hooks'
import { CountryPOSList, UserPOS, UserPOSActions } from '@/redux/actions'
import { ApplicationState } from '@/redux/stores/types'

export const useUserPOS = createLoadOnceAPIHook<{}, ApplicationState['userPOS']>({
	loadAction: (_, { onLoad, onError }) => UserPOSActions.getUserPOS(onLoad, onError),
	isEmpty: (userPOS) => !userPOS,
	loadingSelectors: UserPOS.GetUserPOS,
	storeMapper: ({ userPOS }) => userPOS,
})

export const useCountryPOS = createLoadOnceAPIHook<[], ApplicationState['posList']>({
	loadAction: (_, { onLoad, onError }) => UserPOSActions.getCountryPOSList(onLoad, onError),
	isEmpty: (POSList) => !POSList.length,
	loadingSelectors: CountryPOSList.GetCountryPOSList,
	storeMapper: ({ posList }) => posList,
})
